/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
// Library Imports
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Col, Row, Select, Tooltip, TreeSelect, Typography } from "antd";
// import { Option } from "antd/lib/mentions";
import { useDispatch, useSelector } from "react-redux";
// Local Imports
import { RootState } from "store";
import SelectWithIcon from "modules/Campaigns/Shared/SelectWithIcon";
// actions Imports
import {
  addNode,
  clearDropArea,
  addActionModal,
  editNode,
  setSelectedIfElsesAction,
  getEmailsLinks,
  updateErrorNodes,
} from "../../actions";
import {
  ControlNameEnum,
  ConditionEmails,
  IControls,
  ConditionEnum,
  IShareProfileTemplate,
} from "../../interfaces";
import { findDropAreaData, getConditionEmails } from "../../utils";

const { Option, OptGroup } = Select;
const { Paragraph } = Typography;
type IConditionProps = {
  id: string;
  enableSaveButton: (value: boolean) => void;
};

type IConditionControls = {
  id: string;
  value: ConditionEnum.HAS_CLICKED | ConditionEnum.HAS_OPENED;
  label: ConditionEnum.HAS_CLICKED | ConditionEnum.HAS_OPENED;
};

const IfElseContent = (props: IConditionProps) => {
  // Props
  const { id, enableSaveButton } = props;

  // Redux States
  const emailsLinks: any = useSelector((state: RootState) => state.automation.emailsLinks.data);
  const itemData = useSelector((state: RootState) => state.automation.workflow.flow[id]?.detail);
  const controls: IControls[] = useSelector((state: RootState) => state.automation.controls);
  const dropData = useSelector((state: RootState) => state.automation.workflow.dropArea);
  const modal = useSelector((state: RootState) => state.automation.modals.addAction);
  const shareProfileTemplates: IShareProfileTemplate[] = useSelector(
    (state: RootState) => state.automation.emails.shareProfileTemplates
  );
  const actionModalVisible: boolean = useSelector((state: RootState) => state.automation.modals.addAction.visible);

  // Local Variables
  const dispatch = useDispatch();
  const emails: ConditionEmails[] = getConditionEmails(dropData.id || id, shareProfileTemplates);
  let conditionControls: IConditionControls[] = controls
    .find((control: IControls) => control.name === ControlNameEnum.IF_ELSE)
    ?.conditions?.map((condition) => {
      return {
        id: condition.id,
        value: condition.name,
        label: condition.name,
      };
    }) || [{ id: "", value: "", label: "" }];

  // Local States
  const [selectedCondition, setSelectedCondition] = useState<IConditionControls>(conditionControls[0]);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [selectedLink, setSelectedLink] = useState(null);
  const [selectedLinkType, setSelectedLinkType] = useState(null);
  const [selectedEmailLinks, setSelectedEmailLinks] = useState<any>([]);

  // Component Logic
  function onlyUnique(value: any, index: number, self: any) {
    return self.indexOf(value) === index;
  }

  const onEmailChange = (value: any) => {
    if (
      value === undefined ||
      (selectedEmail !== value && selectedCondition.value === ConditionEnum.HAS_CLICKED)
    ) {
      setSelectedLink(null);
      setSelectedLinkType(null);
      setSelectedEmail(value);
      enableSaveButton(false);
    } else {
      setSelectedEmail(value);
      if (selectedCondition.value !== ConditionEnum.HAS_CLICKED) {
        enableSaveButton(true);
      }
    }
    if (value) {
      let links = emailsLinks[value];
      // let uLinks = links?.filter(onlyUnique);
      setSelectedEmailLinks(links);
    }
  };

  const onLinkChange = (value: any) => {
    let values = value?.split("#-#");
    console.log(value);
    console.log(values);
    // #-#
    if (value !== undefined) {
      setSelectedLink(values[1]);
      setSelectedLinkType(values[0]);
      enableSaveButton(true);
    } else {
      setSelectedLink(null);
      setSelectedLinkType(null);
    }
  };

  const selectHandler = (value: any) => {
    setSelectedCondition(value);
    if (value.id === 4 && !selectedLink) {
      enableSaveButton(false);
      if (selectedEmail) {
        let links = emailsLinks[selectedEmail];
        // let uLinks = links?.filter(onlyUnique) || [];
        setSelectedEmailLinks(links);
      }
    } else if (value.id === 3 && selectedEmail) {
      setSelectedLink(null);
      setSelectedLinkType(null);
      enableSaveButton(true);
    }
  };

  // useEffect to set the data of edit Node
  const isConditionModalOpen = modal.visible === true && modal.tab === ControlNameEnum.IF_ELSE;
  let dependencies = itemData && isConditionModalOpen && emailsLinks;
  useEffect(() => {
    if (isConditionModalOpen && itemData) {
      if (itemData.hasOwnProperty("emailId") || itemData.hasOwnProperty("sp_uuid")) {
        let emailId = itemData?.emailId;
        if (itemData?.sp_uuid) {
          setSelectedEmail(itemData?.sp_uuid);
        } else {
          setSelectedEmail(emailId);
        }
        setSelectedCondition({
          id: itemData.controlId,
          value: itemData.controlName,
          label: itemData.controlName,
        });
        setSelectedEmailLinks(emailsLinks[emailId] || []);
        // if detail object have link attribute equal to some value then set the state of selected links
        // if detail object have link attribute equal to null then we will check the is control Name is "has clicked"
        // if this is the case then we set enableSaveButton to false otherwise (i.e. control Name is "has opened") true
        if (itemData.link && emailsLinks[emailId]) {
          if (itemData?.linkType) {
            let indexOf = emailsLinks[emailId]!.findIndex((item: any) => item.type === 'buttons' ? (itemData?.linkType === 'buttons' || itemData?.linkType === 'articles') : item.type === itemData?.linkType);
            if (indexOf > -1) {
              let linkIndex = emailsLinks[emailId][indexOf]!.options.findIndex((item: any) => item.value === itemData.link);
              if (linkIndex > -1) {
                setSelectedLink(itemData.link);
                setSelectedLinkType(itemData?.linkType)
              }
            }
            // } else if (emailsLinks[emailId]?.includes(itemData.link)) {
          } else {
            setSelectedLink(itemData.link);
            setSelectedLinkType(itemData?.linkType);
          }
        } else if (itemData.controlName === ConditionEnum.HAS_CLICKED) {
          enableSaveButton(false);
        } else {
          enableSaveButton(true);
        }
      }
    } else if (isConditionModalOpen && selectedEmail !== "") {
      setSelectedEmail("");
      setSelectedCondition(conditionControls[0]);
      enableSaveButton(false);
    }
  }, [dependencies]);

  useEffect(() => {
    if (modal.visible === false && selectedEmail !== "") {
      setSelectedEmail("");
      setSelectedLink(null);
      setSelectedLinkType(null);
      setSelectedCondition(conditionControls[0]);
      enableSaveButton(false);
    }
  }, [modal]);
  const submitHandler = (event: any) => {
    event.preventDefault();
    let email = emails.find(
      (email) => selectedEmail === email?.sp_uuid || email.emailId === parseInt(selectedEmail)
    );
    let obj = findDropAreaData(ControlNameEnum.IF_ELSE);
    let title = selectedLink ? ` ${selectedLink === "Any Link" ? "Any Link" : selectedLink}` : `: ${email?.title}`;
    let conditionTime = "5m";

    if (id) {
      // edit Node
      dispatch(
        editNode(id, {
          ...itemData,
          controlName: selectedCondition?.value,
          controlId: selectedCondition?.id,
          emailId: email?.emailId,
          emailName: email?.title,
          link: selectedLink,
          linkType: selectedLinkType,
          nodeTitle: title && title?.includes("undefined") ? "Share Profile" : title,
          conditionTime,
          error: false,
        })
      );
      dispatch(updateErrorNodes(id));
    } else {
      dispatch(
        addNode({
          ...obj,
          controlName: selectedCondition?.value,
          controlId: selectedCondition?.id,
          emailId: email?.emailId,
          emailName: email?.title,
          link: selectedLink,
          linkType: selectedLinkType,
          nodeTitle: title,
          conditionTime,
          emailType: email?.sp_uuid ? "share profile" : "email", // 10 is for shared email
          ...(email?.sp_uuid ? { sp_uuid: email?.sp_uuid } : {}),
        })
      );
    }
    enableSaveButton(false);
    dispatch(addActionModal(false));
    dispatch(clearDropArea());
  };

  useEffect(() => {
    if (selectedCondition && selectedEmail) {
      setSelectedIfElsesAction(parseInt(selectedCondition.id.toString()), parseInt(selectedEmail));
    } else {
      setSelectedIfElsesAction(0, 0);
    }
  }, [selectedCondition, selectedEmail]);

  useEffect(() => {
    if (!actionModalVisible) {
      setSelectedIfElsesAction(0, 0);
      if (selectedEmail && selectedEmail?.length > 0 && selectedEmail?.includes("-")) {
        setSelectedEmail("");
      }
    } else {
      if (emails.length > 0) {
        let ids: string = emails
          .filter((email) => email.emailId)
          .map((email) => email.emailId)
          .join(",");
        getEmailsLinks(ids);
        // call the api for links
      }
    }
  }, [actionModalVisible]);


  return (
    <Wrapper>
      {/* WF Name changes done here */}
      <div className="label-model">Condition</div>
      <div className="condition-wrapper">
        <div className="label-condition">Select a condition</div>
        <form id={`${ControlNameEnum.IF_ELSE}`} onSubmit={submitHandler}>
          <Row gutter={[32, 0]}>
            <Col span={12}>
              <SelectWithIcon
                defaultValue={{ value: "Select a condition", label: "Select a condition" }}
                options={conditionControls}
                onChange={selectHandler}
                value={selectedCondition}
                className="if-else-dropdown"
                menuWidth={267}
              />
            </Col>
            <Col span={12}>
              <Select
                className="condition-dropdown w-100"
                showSearch
                placeholder="Please select email"
                optionFilterProp="children"
                onChange={onEmailChange}
                allowClear
                value={
                  emails.find(
                    (email) => email?.sp_uuid === selectedEmail || email.emailId === parseInt(selectedEmail)
                  )?.title
                }
                // onClear={handleOnClear}
                filterOption={(input, option) =>
                  (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                }
                onClear={() => {
                  setSelectedLink(null);
                  setSelectedLinkType(null);
                  enableSaveButton(false);
                }}
                defaultActiveFirstOption={false}
              // open={true}
              // popupClassName="conditions-list"
              >
                {emails?.map((email: ConditionEmails, index) => {
                  let eId = `${email.emailId === null ? email.sp_uuid : email.emailId}`;
                  if (email.emailId || email.sp_uuid) {
                    return (
                      <Option className="automation-dropdown-option" key={index} value={eId}>
                        {email.title}
                      </Option>
                    );
                  }
                })}
              </Select>
            </Col>
            {selectedCondition.value === ConditionEnum.HAS_CLICKED && selectedEmail && (
              <Col span={12}>
                <Select
                  className="condition-dropdown link-condition w-100"
                  showSearch={false}
                  placeholder="Please select links"
                  // optionFilterProp="children"
                  onChange={onLinkChange}
                  allowClear
                  // open={true}
                  // value={selectedEmailsLinks?.find((linkObj) => linkObj.value === selectedLink)}
                  value={selectedLinkType && selectedLink ? `${selectedLinkType}#-#${selectedLink}` : null}
                  filterOption={(input, option) =>
                    (option!.value as unknown as string).toLowerCase().includes(input.toLowerCase())
                  }
                  onClear={() => {
                    setSelectedLink(null);
                    setSelectedLinkType(null);
                    enableSaveButton(false);
                  }}
                  getPopupContainer={() => document.querySelectorAll(".condition-wrapper")[0] as HTMLElement}
                >
                  {[
                    { value: "Any Link", label: "Any Link" },
                    ...(selectedEmailLinks ? selectedEmailLinks : []),
                  ].map((item: any) => {
                    let obj = item.options ? (
                      item.options.length > 0 ? (
                        <OptGroup label={item.label}>
                          {item?.options?.map((option: any) => {
                            let popoverText = option.label == option.value ? option.label : `${option.label} \n${option.value}`;
                            let value = `${option.type}#-#${option.value}`;
                            let readMoreText =
                              option.type === "articles"
                                ? "Read More"
                                : option.type === "buttons"
                                  ? option.label
                                  : "";
                            let labelText =
                              option.type === "articles"
                                ? `: Article (${option.label})`
                                : option.type === "buttons"
                                  ? ""
                                  : option.label;
                            return (
                              <Option className="text-underlined" value={value}>
                                <Tooltip placement="bottom" title={popoverText}>
                                  <p className="read-more">{readMoreText}</p>
                                  {labelText.length > 0 ? (
                                    <Paragraph className="camp-name" ellipsis={true}>
                                      {labelText}
                                    </Paragraph>
                                  ) : null}
                                </Tooltip>
                                {/* {option.type === "articles" ?
                                  (
                                    <Tooltip placement="bottom" title={`${option.label} \n${option.value}`}>
                                      <p className="read-more">Read More</p>
                                      <Paragraph className="camp-name" ellipsis={true}>
                                        {`: Article (${option.label})`}
                                      </Paragraph>
                                    </Tooltip>
                                  )
                                  : option.type === 'buttons' ?
                                    (
                                      <Tooltip placement="bottom" title={`${option.label} \n${option.value}`}>
                                        <p className="read-more"></p>
                                        <Paragraph className="camp-name" ellipsis={true}>
                                          {`${option.label}`}
                                        </Paragraph>
                                      </Tooltip>
                                    ) : (
                                      <Tooltip placement="bottom" title={`${option.label} \n${option.value}`}>
                                        <p className="read-more"></p>
                                        <Paragraph className="camp-name" ellipsis={true}>
                                          {`${option.label}`}
                                        </Paragraph>
                                      </Tooltip>
                                    )} */}
                              </Option>
                            );
                          })}
                        </OptGroup>
                      ) : null
                    ) : (
                      <Option
                        className={item.label === "Any Link" ? "any-link" : "text-underlined"}
                        value={`Any Link#-#${item.value}`}
                      >
                        {item.label}
                      </Option>
                    );
                    return obj;
                  })}
                </Select>
                {/* {console.log("selectedEmailLinks: ", selectedEmailLinks)}
                <TreeSelect
                  className="condition-dropdown link-condition w-100"
                  showSearch
                  allowClear
                  value={selectedLink}
                  placeholder="Please select links"
                  onChange={onLinkChange}
                  treeData={treeData}
                  // treeData={[
                  //   { value: "Any Link", title: "Any Link", children: [] },
                  //   ...(selectedEmailLinks
                  //     ? selectedEmailLinks?.map((link: any) => ({
                  //       value: null,
                  //       title: "Links",
                  //       children: [{ value: link, title: link }],
                  //     }))
                  //     : []),
                  // ]}
                  onClear={() => {
                    setSelectedLink(null);
                    enableSaveButton(false);
                  }}
                  filterTreeNode={(input, option) =>
                    (option!.value as unknown as string).toLowerCase().includes(input.toLowerCase())
                  }
                  getPopupContainer={() => document.querySelectorAll(".condition-wrapper")[0] as HTMLElement}
                  switcherIcon={" "}
                  treeDefaultExpandAll={true}
                /> */}
              </Col>
            )}
          </Row>
        </form>
        {/* Hiding this for now */}
        {/* <div className="add-condition">
          <img src={AddIcon} alt="" /> Add another condition
        </div> */}
      </div>
    </Wrapper>
  );
};

export default IfElseContent;

const Wrapper = styled.div`
  .condition-wrapper {
    /* .ant-select-item { */
    .ant-select-item-group {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      /* identical to box height, or 100% */
      letter-spacing: -0.4px;
      color: #424b50;
      .ant-select-item-option-content {
        color: #979797;
      }
    }
    /* } */
    .ant-select-item-option-content,
    .ant-select-selection-item {
      color: #979797;
      span {
        align-items: center;
        display: flex;
        color: #979797;
        font-family: "Roboto";
        font-size: 12px;
        text-decoration: underline;
        text-decoration-color: #979797;
        width: 100%;
        .ant-typography-ellipsis-single-line {
          margin-bottom: 0;
          text-decoration: underline;
          color: #979797;
          text-decoration-color: #979797;
        }
        .read-more {
          font-size: 12px;
          color: #27ce0a;
          margin-top: 0;
          margin-bottom: 0;
          text-decoration: underline;
        }
      }
      :hover {
        color: #979797;
      }
    }
    /* .ant-select-item-option-content{
      .ant-typography p {
        margin-bottom: 0;
      }
      font-family: 'Roboto';
      font-size: 12px;
      text-decoration: underline;
      text-decoration-color: #979797;
    } */
    .ant-select-selection-item {
      max-width: 250px !important;
      .ant-typography-ellipsis-single-line {
        width: 90%;
      }
    }
    .ant-select-item-option-content:hover {
      color: #979797;
    }
    .any-link {
      .ant-select-item-option-content {
        font-size: 16px;
        color: #27ce0a;
        text-decoration: underline;
        text-decoration-color: #27ce0a;
      }
    }
    .text-underlined {
      text-decoration: underline;
      text-decoration-color: #979797;
      &.ant-select-item-option-content {
        color: #979797;
      }
      /* :hover {
        text-decoration-color: #27ce0a;
      } */
    }
    .ant-select-item-option-grouped {
      padding-left: 12px;
    }
  }
`;
